// Préférences IDE de l'utilisateur (CCT-80, CCT-81) — persistées sur le profil.
import { apiFetch } from './client';

export type SyntaxScheme = 'neon' | 'soft';

export interface IdeSettings {
  theme: 'dark' | 'light';        // s'applique à TOUT l'IDE (chrome + éditeur)
  syntaxScheme: SyntaxScheme;     // deux jeux de coloration au choix
  fontSize: number;
  font: string;
  lineNumbers: boolean;
}

export const DEFAULT_IDE: IdeSettings = {
  theme: 'dark', syntaxScheme: 'neon', fontSize: 13, lineNumbers: true,
  // Consolas par défaut (demandé) ; repli monospace pour les postes qui ne l'ont pas.
  font: "Consolas, 'Courier New', ui-monospace, monospace",
};

const A = (token: string | null) => ({ token, auth: true as const });

export const getIdeSettings = (token: string | null) =>
  apiFetch<{ ide: Partial<IdeSettings> }>('/me/prefs/ide', A(token));

export const putIdeSettings = (token: string | null, ide: IdeSettings) =>
  apiFetch<{ ide: IdeSettings }>('/me/prefs/ide', { ...A(token), method: 'PUT', body: ide });
